import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'urlFile': '',
  'listByOrders': [],
};

export const boReport = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_REPORT_BO]: (state, action) => ({
      ...state,
      'loading': true,
      'loadButton': true,
    }),
    [ActionTypes.FETCHED_REPORT_BO]: (state, action) => ({
      ...state,
      'list': action.response.data,
      'loading': false,
    }),
    [ActionTypes.FETCHED_REPORT_BO_FAILED]: (state, action) => ({
      ...state,
      'list': [],
      'loading': false,
    }),
    [ActionTypes.FETCHING_REPORT_BO_EXCEL]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_REPORT_BO_EXCEL]: (state, action) => ({
      ...state,
      'loading': false,
      'urlFile': action.response.data,
    }),
    [ActionTypes.FETCHED_REPORT_BO_EXCEL_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'urlFile': '',
    }),
    [ActionTypes.DELETE_BO_REPORT]: () => ({
      ...state,
      'list': [],
      'loading': false,
      'urlFile': '',
    }),
    [ActionTypes.DELETE_BO_REPORT_URL]: () => ({
      ...state,
      'urlFile': '',
    }),
    [ActionTypes.FETCHING_REPORT_BY_ORDERS_BO]: (state, action) => ({
      ...state,
      'loading': true,
      'loadButton': true,
    }),
    [ActionTypes.FETCHED_REPORT_BY_ORDERS_BO]: (state, action) => ({
      ...state,
      'listByOrders': action.response.data,
      'loading': false,
    }),
    [ActionTypes.FETCHED_REPORT_BY_ORDERS_BO_FAILED]: (state, action) => ({
      ...state,
      'listByOrders': [],
      'loading': false,
    }),
  })(state, action);
};
